import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { Camera } from '@ionic-native/camera';
import { MobileAccessibility } from '@ionic-native/mobile-accessibility';
import { Market } from '@ionic-native/market';

import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Clipboard } from '@ionic-native/clipboard';

import { AccountPageModule } from '../pages/account/account.module';
import { ActiveconfirmPageModule } from '../pages/activeconfirm/activeconfirm.module';
import { ActivedepositPageModule } from '../pages/activedeposit/activedeposit.module';
import { ActivepopupPageModule } from '../pages/activepopup/activepopup.module';
import { ApplyPageModule } from '../pages/apply/apply.module';
import { BonuslistPageModule } from '../pages/bonuslist/bonuslist.module';
import { BuyitemPageModule } from '../pages/buyitem/buyitem.module';
import { ChangepassPageModule } from '../pages/changepass/changepass.module';
import { CommonmodalPageModule } from '../pages/commonmodal/commonmodal.module';
import { CompletePageModule } from '../pages/complete/complete.module';
import { CreatemodalPageModule } from '../pages/createmodal/createmodal.module';
import { EmailauthPageModule } from '../pages/emailauth/emailauth.module';
import { EntryPageModule } from '../pages/entry/entry.module';
import { ForgotPageModule } from '../pages/forgot/forgot.module';
import { HuwonPageModule } from '../pages/huwon/huwon.module';
import { HuwonpopPageModule } from '../pages/huwonpop/huwonpop.module';
import { ItemshistoryPageModule } from '../pages/itemshistory/itemshistory.module';
import { LoginPageModule } from '../pages/login/login.module';
import { LogoutModalPageModule } from '../pages/logout-modal/logout-modal.module';
import { MyaccountPageModule } from '../pages/myaccount/myaccount.module';
import { MyactivePageModule } from '../pages/myactive/myactive.module';
import { MygroupPageModule } from '../pages/mygroup/mygroup.module';
import { MypagePageModule } from '../pages/mypage/mypage.module';
import { NotificationPageModule } from '../pages/notification/notification.module';
import { NotifimodalPageModule } from '../pages/notifimodal/notifimodal.module';
import { NotifipopupPageModule } from '../pages/notifipopup/notifipopup.module';
import { ProfitlistPageModule } from '../pages/profitlist/profitlist.module';
import { QnaPageModule } from '../pages/qna/qna.module';
import { QnaformPageModule } from '../pages/qnaform/qnaform.module';
import { QnalistPageModule } from '../pages/qnalist/qnalist.module';
import { StakingPageModule } from '../pages/staking/staking.module';
import { WalletPageModule } from '../pages/wallet/wallet.module';
import { HttpService } from '../services/HttpService';
import { HttpClientModule } from '@angular/common/http';
import { CreatewallPageModule } from '../pages/createwall/createwall.module';
import { WithdrawalcoinPageModule } from '../pages/withdrawalcoin/withdrawalcoin.module';
import { WithdrawalcoinlistPageModule } from '../pages/withdrawalcoinlist/withdrawalcoinlist.module';
import { WithdrawalPageModule } from '../pages/withdrawal/withdrawal.module';
import { ApplylistPageModule } from '../pages/applylist/applylist.module';
import { AvatalistPageModule } from '../pages/avatalist/avatalist.module';
import { ManagementPageModule } from '../pages/management/management.module';
import { ApplypointPageModule } from '../pages/applypoint/applypoint.module';
import { ApplypointlistPageModule } from '../pages/applypointlist/applypointlist.module';
import { WithdrawalpointPageModule } from '../pages/withdrawalpoint/withdrawalpoint.module';
import { WithdrawalpointlistPageModule } from '../pages/withdrawalpointlist/withdrawalpointlist.module';
import { WithdrawalconfirmPageModule } from '../pages/withdrawalconfirm/withdrawalconfirm.module';
import { CountdownPageModule } from '../pages/countdown/countdown.module';
import { CashroomPageModule } from '../pages/cashroom/cashroom.module';
import { BonusroomPageModule } from '../pages/bonusroom/bonusroom.module';
import { TransferPageModule } from '../pages/transfer/transfer.module';
import { BonusdetailPageModule } from '../pages/bonusdetail/bonusdetail.module';
import { RoomdetailPageModule } from '../pages/roomdetail/roomdetail.module';
import { StakinglistPageModule } from '../pages/stakinglist/stakinglist.module';
import { StakingconfirmPageModule } from '../pages/stakingconfirm/stakingconfirm.module';
import { StakingcompletePageModule } from '../pages/stakingcomplete/stakingcomplete.module';
import { P2pPageModule } from '../pages/p2p/p2p.module';
import { TransfercompletePageModule } from '../pages/transfercomplete/transfercomplete.module';
import { TransferconfirmPageModule } from '../pages/transferconfirm/transferconfirm.module';
import { AccountconfirmPageModule } from '../pages/accountconfirm/accountconfirm.module';
import { MultiaccountsPageModule } from '../pages/multiaccounts/multiaccounts.module';
import { MultiregistPageModule } from '../pages/multiregist/multiregist.module';
import { DeleteaccountPageModule } from '../pages/deleteaccount/deleteaccount.module';
import { DbclistPageModule } from '../pages/dbclist/dbclist.module';
import { RegisteraddressPageModule } from '../pages/registeraddress/registeraddress.module';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@NgModule({
    declarations: [
        MyApp,
        AboutPage,
        ContactPage,
        HomePage,
        TabsPage
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(MyApp,{
            modalEnter: 'modal-slide-in',
            modalLeave: 'modal-slide-out',
            pageTransition: 'ios-transition'
        }),
        HttpClientModule,
        AccountPageModule,
        ActiveconfirmPageModule,
        ActivedepositPageModule,
        ActivepopupPageModule,
        ApplyPageModule,
        BonuslistPageModule,
        BuyitemPageModule,
        ChangepassPageModule,
        CommonmodalPageModule,
        CompletePageModule,
        CreatemodalPageModule,
        CreatewallPageModule,
        EmailauthPageModule,
        EntryPageModule,
        ForgotPageModule,
        HuwonPageModule,
        HuwonpopPageModule,
        ItemshistoryPageModule,
        LoginPageModule,
        LogoutModalPageModule,
        MyaccountPageModule,
        MyactivePageModule,
        MygroupPageModule,
        MypagePageModule,
        NotificationPageModule,
        NotifimodalPageModule,
        NotifipopupPageModule,
        ProfitlistPageModule,
        QnaPageModule,
        QnaformPageModule,
        QnalistPageModule,
        StakingPageModule,
        WalletPageModule,
        WithdrawalPageModule,
        WithdrawalcoinPageModule,
        WithdrawalcoinlistPageModule,
        ApplylistPageModule,
        AvatalistPageModule,
        ManagementPageModule,
        ApplypointPageModule,
        ApplypointlistPageModule,
        WithdrawalpointPageModule,
        WithdrawalpointlistPageModule,
        WithdrawalconfirmPageModule,
        CountdownPageModule,
        CashroomPageModule,
        BonusroomPageModule,
        TransferPageModule,
        BonusdetailPageModule,
        RoomdetailPageModule,
        StakinglistPageModule,
        StakingconfirmPageModule,
        StakingcompletePageModule,
        P2pPageModule,
        TransfercompletePageModule,
        TransferconfirmPageModule,
        AccountconfirmPageModule,
        MultiaccountsPageModule,
        MultiregistPageModule,
        DeleteaccountPageModule,
        DbclistPageModule,
        RegisteraddressPageModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        AboutPage,
        ContactPage,
        HomePage,
        TabsPage
    ],
    providers: [
        StatusBar,
        SplashScreen,
        InAppBrowser,
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        HttpService,
        Camera,
        MobileAccessibility,
		Market,
        Clipboard
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts